export default __webpack_public_path__ + "static/media/website.68595623.svg";